export default "__VITE_ASSET__30ea8407__"